<section class="w-full relative">
  <label for="mySelect" class="block text-sm font-medium text-gray-700 dark:text-slate-300 mb-2">
    {{ label() }}
    @if (showAsteric()) {
      <span class="text-error">*</span>
    }
  </label>
  <select
    id="mySelect"
    [value]="value"
    [disabled]="disabled"
    (change)="handleChange($event)"
    (blur)="onTouched()"
    class="w-full h-12 px-4 bg-white dark:bg-slate-800 border border-gray-300 dark:border-slate-600 rounded-lg text-sm text-gray-900 dark:text-white
    focus:outline-none focus:ring-1 focus:ring-gray-400 dark:focus:ring-slate-500 focus:border-gray-400 dark:focus:border-slate-500
    disabled:bg-gray-100 dark:bg-slate-700 disabled:cursor-not-allowed
    appearance-none cursor-pointer transition-colors"
  >
    @if (!value) {
      <option value="" disabled selected class="text-gray-500 dark:text-slate-400">Select...</option>
    }
    @for (option of options(); track $index) {
      <option [value]="option.name" [selected]="value === option.name">{{ option.name }}</option>
    }
  </select>
  
  <!-- Custom dropdown arrow -->
  <div class="pointer-events-none absolute right-3 top-[50%] translate-y-[-50%]">
    <svg class="w-4 h-4 text-gray-500 dark:text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"></path>
    </svg>
  </div>
</section>
